'use client';

import { c as _c } from "react/compiler-runtime";
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AuthMutation, AuthQueryOptions } from '@/api';
export interface ScratchSessionData {
  /** 남은 행운권 수(이어서 열기 가능 여부 판단) */
  remainingLuckyTicketCount: number;
  /** 직전 열기 지급 포인트 */
  rewardPoint: number;
}

/**
 * 열기 지급(전면영상 시청 후 호출). POST /external/adpopcorn-ssp(INTERSTITIAL_VIDEO)의
 * 응답 context.scratch({wonPoint, luckyTicketCount})가 결과 화면 데이터다.
 * 지급 멱등은 서버 책임(응답 scratch.alreadyProcessed).
 */
export const useScratch = () => {
  const $ = _c(3);
  const queryClient = useQueryClient();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = AuthMutation["post:/wello/v2/auth/external/adpopcorn-ssp"]();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== queryClient) {
    t1 = {
      ...t0,
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: AuthQueryOptions["get:/wello/v2/auth/benefit-tickets"]().queryKey
        });
      }
    };
    $[1] = queryClient;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return useMutation(t1);
};